import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroAbout from "../components/HeroAbout";
import Para from "../components/para";
import AboutA from "../components/AboutA";
import Manufacturing from "../components/Manufacturing";
import Footer from "../components/Footer";
import FAQabout from "../components/FAQabout";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function Aboutus() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <HeroAbout />
      <Para />
      <AboutA />
      <Manufacturing />
      <FAQabout />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
